"use client";

import { InputHTMLAttributes, useState } from "react";
import PhoneInput from "react-phone-input-2";
import ru from "react-phone-input-2/lang/ru.json";

import "react-phone-input-2/lib/style.css";

import { DEFAULT_LANGUAGE, useTranslation } from "@Shared/i18n";
import { Locale } from "@Shared/types";

import styles from "./Phone.module.scss";

export type InputPhoneProps = InputHTMLAttributes<HTMLInputElement>;

export const InputPhone: React.FC<InputPhoneProps> = props => {
    const [isValid, setIsValid] = useState<boolean>(false);

    const { t } = useTranslation();

    const isLocaleRu = DEFAULT_LANGUAGE === Locale.ru;

    return (
        <PhoneInput
            inputProps={{
                "data-is-valid": isValid,
                ...props,
            }}
            disabled={props.disabled}
            localization={isLocaleRu ? ru : undefined}
            country={isLocaleRu ? "ru" : "us"}
            preferredCountries={isLocaleRu ? ["ru", "by", "kz"] : undefined}
            enableSearch
            disableSearchIcon
            masks={{
                ru: "(...) ...-..-..",
            }}
            searchPlaceholder={t("common.inputPhoneSearch.placeholder")}
            searchNotFound={t("common.inputPhoneSearch.notFound")}
            specialLabel={""}
            value={props.value as string}
            isValid={(inputNumber, country: any) => {
                setTimeout(() => {
                    setIsValid(country.format.split("").filter((s: string) => s === ".").length === inputNumber.length);
                }, 0);

                return true;
            }}
            containerClass={styles.component}
        />
    );
};
